import React, { useState } from 'react';
import { QuestionIcon } from '@fronton/icons-react';
import { HintCloseButton, HintContent, Hint as FrontonHint } from 'fronton-react';
import { TLocaleText } from 'entries/common/widgets/context';
import { getLabelText } from '../../helpers';

type TProps = {
  content: TLocaleText[];
};

export const Hint = ({ content }: TProps) => {
  const [isShowHint, setIsShowHint] = useState<boolean>(false);

  const handleClickHint = () => {
    setIsShowHint(false);
  };

  const handlePressHint = () => setIsShowHint(!isShowHint);

  return (
    <FrontonHint
      open={isShowHint}
      anchor={<QuestionIcon onClick={handlePressHint} type="outline" size="l" color="text-primary" />}
      placement="top"
      closeButton={<HintCloseButton onClick={handleClickHint} />}>
      <HintContent paragraph={getLabelText(content)} data-testid="field-hint-content" />
    </FrontonHint>
  );
};
